// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-picture-padding[data-v-c6b146ca]{margin-top:52%}@media only screen and (max-width:768px){.preview-picture-padding[data-v-c6b146ca]{margin-top:70%}}.preview-container[data-v-c6b146ca]:before{display:block;content:\"\";background:#000;height:1px;z-index:40;position:relative}.blog-img[data-v-c6b146ca]{position:absolute;top:-40px;z-index:30}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
